import React from 'react';
import './MaintenancePage.css'; // Importa gli stili per la pagina di manutenzione

function MaintenancePage() {
    return (
        <div className="maintenance-container">
            <div className="maintenance-content">
                <div className="spinner"></div>
                <h1>Site Under Maintenance</h1> {/* Tradotto */}
                <p>I am working to improve my website. It will be back online shortly!</p> {/* Tradotto */}
                <p>Thank you for your patience.</p> {/* Tradotto */}
            </div>
        </div>
    );
}

export default MaintenancePage;
